import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );
  var logoSize = 150;
  if(window.innerWidth > 1200){
    logoSize = 300
  }
  else if(window.innerWidth > 768){
    logoSize = 250;
  }
  else if(window.innerWidth > 600){
    logoSize = 200;
  }

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0" >
          <Image
            src={require('./../../../assets/images/Logo_Day.png')}
            alt="Eduverse"
            width={logoSize}
          />
      </h1>
    </div>
  );
}

export default Logo;